import {submitFormData, submitJsonData, submitMultipartFormData} from "../../redare/utils/Request";

/**
 * Created by RdevPlugins.JsPresenterBuilderAction on 2021-11-23 10:13:03.
 */

/**
 * @param body: {key, platform, id, enabled, incDel}
 * @param query: {curPage,pageSize}
 * @returns Promise
 */
export function findPlatformList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/platform/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {key, platform, id, enabled, incDel}
 * @param query: {}
 * @returns Promise
 */
export function findPlatformAll(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/platform/all',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

/**
 * @param body: {id, platform, userPlatform, type, key, code, admin, defaults, canDel, platformUnionUserPlatform}
 * @param query: {}
 * @returns Promise
 */
export function findPlatformRoleList(body, query) {

    return new Promise((resolve, reject) => {

        submitJsonData({
            url: '/api/platform/role/list',
            bodyParams: body,
            urlParams: query
        }).then(
            result => {
                resolve(result);
            },
            error => reject(error)
        );
    });
}

